import { environment } from 'src/environment';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { K_QUERY_PARAM_TV, K_QUERY_PARAM_APPLE_TV } from '../../constants';
import { SOCIAL_APP_TV_FLAG, SOCIAL_SMART_APP_TV_FLAG, VOUCHER_SIGNIN } from '../../constants/local.constants';
import { NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'app-account-created',
  templateUrl: './account-created.component.html',
  styleUrls: ['./account-created.component.scss'],
  standalone: true,
  imports: [NgClass, LottieComponent]
})
export class AccountCreatedComponent implements OnInit {

  @Input() nextBillingDate;
  @Input() btnText: string;
  @Input() subTitleText: string;
  @Input() paymentDialog = false;
  @Input() pageDetail;

  options: AnimationOptions = {
    path: `../../../branding/theme/assets/static_assets/ic-success.svg`,
  };
  coupon_valid: string = '';
  accountCreate = true;

  skinName = environment.skinName;
  constructor(public baseService: BaseService, public configService: ConfigurationService, private router: Router,
    private storageService: StorageService, private route: ActivatedRoute,
    private settingsService: SettingsService) {
    this.baseService.loaderSource.next(false);
    const uId = this.storageService.getLocalStore('u_id');
    if (!uId) this.router.navigateByUrl('/home');
    if (this.router.url === '/voucher/success') {
      const voucherSigin = this.storageService.getLocalStore(VOUCHER_SIGNIN);
      if (voucherSigin === '1') this.accountCreate = false;
    }
  }

  ngOnInit(): void {
    this.coupon_valid = this.route.snapshot.queryParams?.coupon_code ?? '';
    this.storageService.removeLocalStore(VOUCHER_SIGNIN);
    this.storageService.removeLocalStore('discount_type');
    this.storageService.removeLocalStore('discount_code');
    this.storageService.removeLocalStore('operator_voucher');
  }

  mobileNavigate() {
    const queryParams = this.route.snapshot.queryParams;
    const socailAppTvFlag = this.storageService.getLocalStore(SOCIAL_APP_TV_FLAG);
    const socailSmartTvFlag = this.storageService.getLocalStore(SOCIAL_SMART_APP_TV_FLAG);
    const contentURL = this.storageService.getLocalStore('contentURL');
    const livePage = this.router.url.match('/live/');
    this.storageService.removeLocalStore('ideal_pay_success');
    if (queryParams.user_type == '1') {
      this.storageService.setLocalStore('event_user_status', queryParams.user_type);
      this.storageService.setLocalStore('payment_valid_success', '0');
    }
    if (queryParams.app === K_QUERY_PARAM_TV || socailAppTvFlag === '1') {
      this.storageService.removeLocalStore(SOCIAL_APP_TV_FLAG);
      if (this.settingsService.activateYourTvFromTVCode) this.router.navigateByUrl('account/activate-tv');
      if (this.settingsService.activateYourTvFromWebCode) this.router.navigateByUrl('account/authenticate');
    } else if (queryParams.app === K_QUERY_PARAM_APPLE_TV || socailSmartTvFlag === '1') {
      this.storageService.removeLocalStore(SOCIAL_SMART_APP_TV_FLAG);
      if (this.settingsService.activateYourTvFromTVCode) this.router.navigateByUrl('account/activate-tv');
      if (this.settingsService.activateYourTvFromWebCode) this.router.navigateByUrl('account/authenticate');
    } else if (contentURL && !(this.baseService.showIosApp || this.baseService.showAndroidApp)) {
      this.storageService.removeLocalStore('contentURL');
      location.href = contentURL;
    } else {
      if (this.router.url.match('/home')) {
        location.reload();
      } else {
        const profileId = this.storageService.getSessionStore('profileId');
        // if maxUserProfiles is 0, it means profiles feature disabled
        if (this.settingsService.maxUserProfiles > 0 && !profileId) {
          this.router.navigateByUrl('/auth/user-profiles');
        } else {
          this.router.navigateByUrl('/home');
        }
      }
    }
  }

}
